import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ num, eyebrow, title, desc, dark = false, className = "" }) => (
  <div className={className}>
    <Reveal>
      <div className="flex items-center gap-4">
        <span className={`font-display text-sm font-extrabold ${dark ? "text-aqua" : "text-iris"}`}>{num}</span>
        <span className="h-px w-12 bg-gradient-to-r from-iris to-aqua" />
        <span className={`text-xs font-bold uppercase tracking-[0.28em] ${dark ? "text-aqua" : "text-steel"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    {title && (
      <Reveal delay={0.08}>
        <h2
          className={`mt-6 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${
            dark ? "text-white" : "text-navy"
          }`}
        >
          {title}
        </h2>
      </Reveal>
    )}
    {desc && (
      <Reveal delay={0.16}>
        <p className={`mt-5 max-w-xl text-base leading-relaxed ${dark ? "text-slate-300" : "text-steel"}`}>{desc}</p>
      </Reveal>
    )}
  </div>
);
